import { render } from "./ImportStudents.vue?vue&type=template&id=38831320&scoped=true"
import script from "./ImportStudents.vue?vue&type=script&lang=js"
export * from "./ImportStudents.vue?vue&type=script&lang=js"

import "./ImportStudents.vue?vue&type=style&index=0&id=38831320&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38831320"]])

export default __exports__